<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import Intersect from 'vue-intersect';

export default {
  mixins: [fandomBasicMixin],
  components: {
    Intersect
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  computed: {
    currentSlide() {
      return this.content.slides[this.currentIndex];
    },
    slidesCount() {
      return this.content.slides.length;
    },
    backgroundStyle() {
      const style = {};
      const slideBackground = this.currentSlide.background_image?.url;
      const stripeBackground = this.content.background_image?.url;
      const backgroundUrl = slideBackground || stripeBackground;
      const backgroundSize = this.content.background_size;

      style['background-image'] = backgroundUrl ? `url('${backgroundUrl}')` : null;
      style['background-size'] = backgroundSize ? backgroundSize : 'cover';

      return style;
    },
    isMobile() {
      return globalState.viewport.sm || globalState.viewport.xs;
    },
    circleStyle() {
      return { width: this.content.image_size || '15rem' };
    }
  },
  methods: {
    textClass(slide) {
      const position = slide.text_position;
      const justifyContent = `justify-content-${position}`;

      let textAlign = 'text-center';
      if (!this.isMobile) {
        switch(position) {
          case 'start':
            textAlign = 'text-left';
            break;
          case 'end':
            textAlign =' text-right';
            break;
        }
      }

      return [justifyContent, textAlign];
    },
    slideEnter(index) {
      this.currentIndex = index;
    },
    circleContainerStyle(slide, index) {
      const xOffset = slide.image_x_offset || 0;
      const yOffset = slide.image_y_offset || 0;
      const opacity = this.currentSlide.show_all_images || index == this.currentIndex ? 1 : 0.25

      return {
        top: `calc(50% + ${yOffset})`,
        left: `calc(50% + ${xOffset})`,
        opacity: opacity
      }
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" stripe-vertical-carousel-component>
    <div class="carousel-container d-flex align-items-center" :style="backgroundStyle">
      <div class="position-absolute h-full w-100 overflow-hidden">
        <template v-for="slide, index in content.slides">
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div
              v-if="slide.image"
              v-show="currentIndex >= index" 
              class="circle-container align-items-center justify-content-center"
              :class="{'d-flex': currentIndex >= index}"
              :style="circleContainerStyle(slide, index)"
            >
              <img :src="slide.image.url" class="circle" :style="circleStyle"/>
              <div v-if="slide.image_text && currentSlide.show_all_images" class="position-absolute h3 text-white mb-0">{{ slide.image_text }}</div>
            </div>
          </transition>
        </template>
      </div>
      <div class="carousel-dots position-absolute d-flex flex-column p-3 p-md-4">
        <span v-for="dot in slidesCount" :class="{active: (dot - 1) == currentIndex}"></span>
      </div>
      <div class="slides-container h-full flex-grow-1 overflow-auto text-white">
        <intersect v-for="slide, index in content.slides" @enter="slideEnter(index)" :threshold="[0.5]" :key="slide.$id">
          <div class="slide d-flex h-full w-100 align-items-center" :class="textClass(slide)">
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
              <div v-show="index == currentIndex" class="col-12 col-md-8 col-lg-6 col-xl-5 p-5 p-md-6">
                <p v-if="slide.category" class="h3">{{ slide.category }}</p>
                <h2 v-if="slide.title" class="display-2">{{ slide.title }}</h2>
                <p v-if="slide.description" v-html="slide.description"></p>
              </div>
            </transition>
          </div>
        </intersect>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-vertical-carousel-component] {

  .carousel-container {
    background-repeat: no-repeat;
    background-position: center;
    background-color: $primary;
  }

  .slides-container {
    scroll-snap-type: y mandatory;
    scroll-behavior: smooth;
    z-index: 10;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .slide {
    scroll-snap-align: center;
  }

  .carousel-dots {
    right: 0;

    > span {
      height: 6px;
      width: 6px;
      background-color: white;
      margin: 0.25rem 0;
      border-radius: 6px;

      &.active {
        background-color: $dark !important;
      }
    }
  }

  @include media-breakpoint-up(md) {
    .p-md-6{
      padding: ($spacer * 6) !important;
    }
  }

  .circle-container {
    position: absolute;
    translate: -50% -50%;
    transition: opacity 0.5s;
  }

  .circle {
    height: auto;
  }
}
</style>